<template>
  <v-app light>
    <!--
     <v-app-bar app :src="getBannerSrc()"
                   :height="100" flat>
          <template v-slot:img="{ props }">
            <v-img v-bind="props"></v-img>
          </template>
</v-app-bar>
-->
    <v-content>
      <v-container v-show="showMainItem" class="primary" fluid>
        <v-card flat>
          <v-card-text class="title font-weight-bold">
            <v-row no-gutters>
              <v-col>{{ labels.orderAmount[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ totalAmount }}
              </v-col>
            </v-row>
            <v-row v-show="isDelivery" no-gutters>
              <v-col>{{ labels.deliveryPrice[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ deliveryPrice }}
              </v-col>
            </v-row>
            <v-row v-show="serviceFee" no-gutters>
              <v-col>{{ labels.serviceFee[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ serviceFee }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-divider></v-divider>
            </v-row>
            <v-row no-gutters>
              <v-col>{{ labels.total[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ totalAmount + deliveryPrice + serviceFee }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container v-show="showMainItem" fluid>
        <v-card flat class="mt-3">
          <v-row justify="center" class="pb-2">
            <div class="primary--text title font-weight-bold">{{ labels.payBy[language] }}</div>
          </v-row>
          <v-row v-for="row_n in Math.ceil(_paymentTypes.length / 3)" :key="`row_key_${row_n}`">
            <v-col v-for="col_paymentItem in _paymentTypes.slice((row_n - 1) * 3, row_n * 3)"
              :key="`col_key_${col_paymentItem.name}`" cols="4">
              <v-card class="mx-auto" @click="doPayment(col_paymentItem)" align="center" flat>
                <v-img width="100" :src="require(`../assets/image/${col_paymentItem.image}`)"
                  :style="`border:2px solid ${$vuetify.theme.themes.light.primary} border-radius: 10%`">
                </v-img>
                <v-card-text class="headline font-weight-bold" align="center">
                  <div>{{
                    col_paymentItem.label[language].split(',')
                      .join('\n')
                  }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-container fluid v-show="showCard">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" width="800" align="center" flat>
            <v-img height="362" width="367" :src="require('../assets/image/ill_credit_card.png')">
            </v-img>
            <v-card-text class="title font-weight-bold mt-10
            " align="center">
              <div>請將卡片靠近刷卡機上方<br />或由下方插入晶片卡</div>
            </v-card-text>
            <v-card-text v-show="errorText" class="title red--text font-weight-bold mt-10" align="center">
              {{ errorText }}
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showEStoredValue">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" width="800" align="center" flat>
            <v-img height="362" width="367" :src="require('../assets/image/ill_credit_card.png')">
            </v-img>
            <v-card-text class="title font-weight-bold mt-10" align="center">
              <div>請將卡片靠近刷卡機上方</div>
            </v-card-text>
            <v-card-text v-show="errorText" class="title red--text font-weight-bold mt-10" align="center">
              {{ errorText }}
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showScan">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-img height="412" width="247" :src="require('../assets/image/ill_qrcode_scan.png')">
            </v-img>
            <v-card-text class="title font-weight-bold mt-10" align="center">
              <div>請將付款碼靠近左下方條碼掃描器</div>
            </v-card-text>
            <v-card-text v-show="errorText" class="title red--text font-weight-bold mt-10" align="center">
              {{ errorText }}
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showCounter">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-img height="477" width="396" :src="require('../assets/image/ill_check_out.png')">
            </v-img>
            <v-card-text class="title font-weight-bold mt-10" align="center">
              <div>請持訂單至{{ (isForKiosk) ? '自助繳費機' : '櫃檯' }}結帳<br />餐點將於結帳後開始製作</div>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
    <v-footer padless app color="white">
      <v-container fluid>
        <v-row class="pa-0">
          <v-col class="pr-0 pl-0">
            <v-btn v-show="!isDoPrime" class="subtitle-1 font-weight-bold" color="primary" @click="back"
              :disabled="disableGoBack" block outlined>{{ labels.back[language] }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <tp-credit-card ref="tp-credit-card"></tp-credit-card>
    <payment-invoice ref="payment-invoice"></payment-invoice>
  </v-app>
</template>

<script>
import tpCreditCard from './TPCreditCard.vue';
import paymentInvoice from './PaymentInvoice.vue';
import { deepCopy } from '../assets/functions/deepCopy';

export default {
  name: 'TPCreditCard',
  components: {
    tpCreditCard,
    paymentInvoice,
  },
  props: {},
  data: () => ({
    labels: {
      orderAmount: {
        en_US: 'ORDER',
        zh_TW: '餐點',
      },
      deliveryPrice: {
        en_US: 'DELIVERY',
        zh_TW: '運費',
      },
      total: {
        en_US: 'TOTAL',
        zh_TW: '總計',
      },
      payBy: {
        en_US: 'PAY BY',
        zh_TW: '請選擇付款方式',
      },
      payByScan: {
        en_US: 'PAY BY Scan',
        zh_TW: '請將付款碼靠近左下方條碼掃描器',
      },
      payByCard: {
        en_US: 'PAY BY Card',
        zh_TW: '請將感應式卡片靠近刷卡機上方',
      },
      payByEValue: {
        en_US: 'PAY BY eValue',
        zh_TW: '請將電子票證靠近刷卡機上方',
      },
      back: {
        en_US: 'BACK',
        zh_TW: '返回上一步',
      },
      serviceFee: {
        en_US: 'Service Fee',
        zh_TW: '服務費',
      },
    },
    showMainItem: true,
    showCard: false,
    showEStoredValue: false,
    showScan: false,
    showCounter: false,
    disableGoBack: false,
    dialogPayment: false,
    dialogPaymentItem: {},
    errorText: '',
    allPaymentTypes: [
      {
        paymentTypeId: '4',
        name: 'linepay',
        label: {
          zh_TW: 'LINE Pay',
          en_US: 'LINE Pay',
        },
        image: 'ic_line_pay.png',
      },
      {
        paymentTypeId: 'jkopay',
        name: 'jkopay',
        label: {
          zh_TW: '街口支付',
          en_US: 'JKOPAY',
        },
        image: 'ic_jko_pay.png',
      },
      {
        paymentTypeId: '1',
        name: 'counter',
        label: {
          zh_TW: '櫃台結帳',
          en_US: 'COUNTER',
        },
        image: 'ic_counter.png',
      },
      {
        paymentTypeId: '9',
        name: 'prepaid',
        label: {
          zh_TW: '外帶自取付款',
          en_US: 'PREPAID',
        },
        image: 'ic_prepaid.png',
      },
    ],
    TapPayTypes: [
      {
        paymentTypeId: 'TapPay',
        name: 'tp-creditcard',
        label: {
          zh_TW: '信用卡',
          en_US: 'CREDITCARD',
        },
        image: 'ic_CreditCard.png',
      },
      {
        paymentTypeId: 'TapPay',
        name: 'tp-linepay',
        label: {
          zh_TW: 'TP LINE Pay',
          en_US: 'TP LINE Pay',
        },
        image: 'ic_line_pay.png',
      },
      // {
      //   paymentTypeId: 'TapPay',
      //   name: 'tpapplepay',
      //   label: {
      //     zh_TW: 'Apple Pay',
      //     en_US: 'Apple Pay',
      //   },
      //   image: 'ic_ApplePay.png',
      // },
      // {
      //   paymentTypeId: 'TapPay',
      //   name: 'tpjkopay',
      //   label: {
      //     zh_TW: '街口支付',
      //     en_US: 'JKOPAY',
      //   },
      //   image: 'ic_jko_pay.png',
      // },
    ],
    paymentTypes: [],
    isDelivery: '',
    deliveryVender: '',
    isDoPrime: false,
  }),
  methods: {
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    async openPaymentInvoice() {
      try {
        await this.$refs['payment-invoice'].openDialog();
      } catch (error) {
        console.log('error', error);
      }
    },
    async openTPCreditCard({ merchantId }) {
      try {
        this.disableGoBack = true;
        // 呼叫子元件的 openDialog 方法，並處理回傳值
        const result = await this.$refs['tp-credit-card'].openDialog();
        // 根據回傳值進行後續處理
        if (result !== null) {
          const { prime } = result;
          const amount = (this.totalAmount + this.deliveryPrice + this.serviceFee);
          const data = {
            prime,
            amount,
            merchant_id: merchantId,
            details: '',
            cardholder: {
              phone_number: '',
              name: '',
              email: '',
              zip_code: '',
              address: '',
              national_id: '',
            },
            three_domain_secure: true,
          };
          const primeData = {
            type: 'tp-creditcart',
            primeData: data,
          };
          this.$store.dispatch('setPrimeData', primeData);
          this.goNext();
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        this.back();
        this.disableGoBack = false;
      }
    },
    async openTPLinePay({ merchantId }) {
      try {
        this.disableGoBack = true;
        const result = await new Promise((resolve) => {
          TPDirect.linePay.getPrime((res) => {
            if (res.status === 0) {
              resolve({ prime: res.prime });
            } else {
              resolve(null); // 失敗時仍然 resolve，避免程式卡住
            }
          });
        });
        if (result !== null) {
          const { prime } = result;
          const amount = (this.totalAmount + this.deliveryPrice + this.serviceFee);
          const { storeName } = this.$store.getters;
          const data = {
            prime,
            amount,
            merchant_id: merchantId,
            details: storeName,
            cardholder: {
              phone_number: '',
              name: '',
              email: '',
              zip_code: '',
              address: '',
              national_id: '',
            },
          };
          const primeData = {
            type: 'tp-linepay',
            primeData: data,
          };
          this.$store.dispatch('setPrimeData', primeData);
          this.goNext();
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        this.back();
        this.disableGoBack = false;
      }
    },
    async doPayment(paymentType) {
      // console.log('paymentType', paymentType);
      this.$store.dispatch('setOrderContent', { paymentType });
      this.showMainItem = false;
      const { diningIn } = this.$store.getters;
      if (paymentType.name !== 'counter' && diningIn === 'for-here') {
        const { onlyDoPrime } = this.$store.getters;
        const { isInvoice } = this.$store.getters.store0;
        if (isInvoice === 'Y' && onlyDoPrime === false) {
          await this.openPaymentInvoice();
        }
      }
      switch (paymentType.name) {
        // case 'creditcard':
        //   this.showCard = true;
        //   break;
        case 'eStoredValue':
          this.showEStoredValue = true;
          break;
        case 'linepay':
          this.goNext();
          break;
        // case 'jkopay':
        //   this.showScan = true;
        //   break;
        case 'counter':
        case 'prepaid':
          this.showCounter = true;
          // 臨櫃交易直接上傳
          this.$router.push('UPLOAD');
          break;
        case 'tp-creditcard':
          // this.tapPayProps = paymentType.name;
          // this.showTapPay = true;
          this.openTPCreditCard(paymentType);
          break;
        case 'tp-linepay':
          this.openTPLinePay(paymentType);
          break;
        case 'tp-applepay':
          break;
        case 'tp-jkopay':
          break;
        default:
      }
    },
    handleDialogClose() {
      this.dialogPayment = false;
    },
    goNext() {
      this.errorText = '';
      const next = this.$store.getters.nextStatusText;
      this.$router.push(next);
    },
    back() {
      if (this.showMainItem) {
        this.$router.replace('/ORDER');
      } else {
        this.showMainItem = true;
        this.showScan = false;
        this.showCard = false;
        this.showCounter = false;
      }
      this.errorText = '';
    },
  },
  mounted() {
    this.$store.dispatch('setStatus', 'PAYMENT');
    const {
      diningIn,
      deliveryVender,
      onlyDoPrime,
    } = this.$store.getters;

    // TapPay結帳
    if (onlyDoPrime === true) {
      this.isDoPrime = true;
    }

    this.deliveryVender = deliveryVender;
    // LINE PAY
    const _line = this.allPaymentTypes[0];
    let storePaymentType = this.$store.getters.storePaymentType
      .find((type) => (type.paymentTypeId === _line.paymentTypeId) && (type.isShowOnList && type.isShowOnList === 'Y'));
    if (storePaymentType) {
      /* storePaymentType.paymentAmount = this.$store.getters.totalAmount
       + this.$store.getters.order.takeOutInfo.deliveryPrice;
       */
      this.paymentTypes.push({
        ..._line,
        storePaymentType,
      });
    }

    // TapPay
    const _tappay = this.$store.getters.storePaymentType
      .find((type) => (type.paymentTypeName === 'TapPay') && (type.isShowOnList && type.isShowOnList === 'Y'));
    if (_tappay) {
      const TapPayInfo = deepCopy(_tappay.paymentAddtionalInfo);
      const resultArray = Object.entries(TapPayInfo)
        .filter(([key]) => key.startsWith('tp-'))
        .map(([key, value]) => ({ name: key, merchantId: value }));
      this.TapPayTypes.forEach((item) => {
        const match = resultArray.find((i) => i.name === item.name);
        if (match) {
          item.merchantId = match.merchantId;
          this.paymentTypes.push({ ...item, storePaymentType: _tappay });
        }
      });
    }


    let _counter = this.allPaymentTypes[2];
    storePaymentType = this.$store.getters.storePaymentType
      .find((type) => type.paymentTypeId === '1');
    if (storePaymentType) {
      _counter = {
        ..._counter,
        storePaymentType,
      };
    }

    // 內用：櫃檯結帳
    // 外送：現金或匯款
    if (['for-here', 'delivery'].indexOf(diningIn) > -1) {
      storePaymentType = this.$store.getters.storePaymentType
        .find((type) => type.paymentTypeId === '1');

      // this.paymentTypes.push((storePaymentType) ? {
      //   ..._counter,
      //   storePaymentType,
      // } : _counter);
      if (storePaymentType) {
        this.paymentTypes.push(_counter);
      }

      // 外送更改顯示名稱
      if (diningIn === 'delivery') {
        _counter.label.zh_TW = '現金或匯款';
      }
      // 由KIOSK結帳, 更改顯示名稱
      if (this.isForKiosk === true) {
        _counter.label.zh_TW = '繳費機結帳';
      }
    }
    // 外帶
    if (diningIn === 'to-go') {
      // 預付款
      const _prepaid = this.allPaymentTypes[3];
      storePaymentType = this.$store.getters.storePaymentType
        .find((type) => type.paymentTypeId === _prepaid.paymentTypeId);
      if (storePaymentType) {
        if (storePaymentType.isEnable === 'Y') {
          this.paymentTypes.push({
            ..._prepaid,
            storePaymentType,
          });
        } else {
          this.paymentTypes.push(_counter); // COUNTER
        }
      } else {
        this.paymentTypes.push(_counter); // COUNTER
      }
    }

    if (this._paymentTypes.length === 1) {
      const { paymentTypeId } = this._paymentTypes[0];
      // counter
      if (paymentTypeId === '1') {
        this.doPayment(this._paymentTypes[0]);
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    processStatus: {
      get() {
        return this.$store.getters.statusText;
      },
    },
    totalAmount: {
      get() {
        return this.$store.getters.totalAmount;
      },
    },
    deliveryPrice: {
      get() {
        return this.$store.getters.order.takeOutInfo.deliveryPrice || 0;
      },
    },
    serviceFee: {
      get() {
        const {
          diningIn,
          isTakeOutServiceFee,
        } = this.$store.getters;
        if (diningIn === 'for-here') {
          return this.$store.getters.totalServiceFee || 0;
        }
        if (diningIn === 'to-go' && isTakeOutServiceFee) {
          return this.$store.getters.totalServiceFee || 0;
        }
        return 0;
      },
    },
    isForKiosk: {
      get() {
        return this.$store.getters.isForKiosk;
      },
    },
    _paymentTypes: {
      get() {
        const {
          diningIn,
          cashType,
        } = this.$store.getters;
        if (diningIn === 'for-here' && cashType === '3') {
          const result = [];
          this.paymentTypes.forEach((item) => {
            if (item.paymentTypeId === '1') {
              result.push(item);
            }
          });
          return result;
        }
        return this.paymentTypes;
      },
    },
  },
};
</script>
<style></style>
